import { get, post, put } from "../Config";

//GET
export function SearchCounsultlist({ params }) {
  return get({ url: `/api/sb/v1/consultTopic`,params});
}
